import React from 'react';

export const truncateWords = (str: string, no_words: number, ending: string) => str.split(' ').splice(0, no_words).join(' ') + ending;

export const stripHtmlTags = (str?: string) => {
  if (str === null || str === undefined) {
    return '';
  }

  const regex = /(<([^>]+)>)/gi;
  const tmp = React.createElement('div', {children: str});
  return tmp.props.children.replace(regex, '') || '';
};
